<template>
  <!-- 导购管理 -->
  <div>
    <div class="f-search-block">
      <!-- <div>
        企微控件S-员工列表
        <qwContacts
          type="userName"
          openid="employee_number"
          :datas="list"
        />
        企微控件E-员工列表
      </div> -->

      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            员工工号：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.employee_number"
              placeholder="请输入员工工号"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            员工姓名：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.salesperson_name"
              placeholder="请输入员工姓名"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            职务：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.salesperson_job"
              placeholder="请输入职务"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            角色：
          </div>
          <div class="field-item-control">
            <el-select
              v-model="params.special_identity"
              class="select"
              placeholder="请选择"
            >
              <el-option
                label="全部"
                :value="-1"
              />
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            店铺：
          </div>
          <div class="field-item-control">
            <SpSearchStore @chooseStore="chooseStore" />
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          @click="haddleSearch"
        >
          查询
        </el-button>
      </div>
    </div>

    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="haddleRefresh"
      >
        新增成员
      </el-button>
      <el-button
        type="primary"
        @click="haddleBindRole()"
      >
        批量更改角色
      </el-button>
      <el-button
        type="primary"
        @click="handleFreeze()"
      >
        批量更改冻结状态
      </el-button>
      <el-button
        type="primary"
        @click="haddleGuideCode"
      >
        导出成员企微码
      </el-button>
      <!-- <el-button type="primary" @click="relationSalesOrganization"> 批量关联销售组织 </el-button> -->
      <el-button
        type="primary"
        @click="relationShops"
      >
        批量关联店铺
      </el-button>
      <el-button
        type="primary"
        @click="importVisible = true"
      >
        导入关联店铺
      </el-button>
      <el-button
        type="primary"
        @click="handleRetry()"
      >
        批量重试
      </el-button>
    </div>

    <div class="f-table-block">
      <!-- 表格数据 -->
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>

      <el-table
        v-loading="loading"
        :data="list"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />

        <el-table-column
          prop="employee_number"
          label="员工工号"
        />
        <el-table-column
          prop="salesperson_name"
          label="员工姓名"
        />
        <el-table-column
          label="所属销售组织"
          min-width="200px"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.store_name }}
              <div v-if="scope.row.store_bn">
                编号：{{ scope.row.store_bn }}
              </div>
              <div v-if="scope.row.group && scope.row.group.length === 1">
                {{ scope.row.group[0].group_name }}
              </div>
              <div v-if="scope.row.group && scope.row.group.length > 1">
                已关联{{ scope.row.group.length }}个区域
                <el-button
                  type="text"
                  @click="showGroupDetail(scope.row)"
                >
                  查看
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
          width="60"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.employee_status === 1">员工</span>
            <span v-else-if="scope.row.employee_status === 2">编外</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="启用">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.salesperson_status === 1"
              type="success"
              size="mini"
              effect="dark"
            >
              启用
            </el-tag>
            <el-tag
              v-else-if="scope.row.salesperson_status === 2"
              type=""
              size="mini"
              effect="dark"
            >
              已冻结
            </el-tag>
            <span v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="salesperson_job"
          label="员工职务"
        >
          <template slot-scope="scope">
            {{ scope.row.salesperson_job || '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          width="160"
          label="更新时间"
        >
          <template slot-scope="scope">
            {{ scope.row.updated_at || '--' }}
          </template>
        </el-table-column>
        <el-table-column
          label="角色权限"
          width="100px"
        >
          <template slot-scope="scope">
            <span>{{ options[scope.row.special_identity] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="同步云店状态">
          <template slot-scope="scope">
            <span v-if="scope.row.is_sync_yundian === 1">成功</span>
            <span v-if="scope.row.is_sync_yundian === 0">失败</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          min-width="200px"
        >
          <template slot-scope="scope">
            <template
              v-if="scope.row.salesperson_status === 1 || scope.row.salesperson_status === 2"
            >
              <!-- <el-button
              v-if="!scope.row.role_name"
              type="text"
              size="small"
              @click="haddleBindRole(scope.row)"
            >
              绑定角色
            </el-button>
            <el-button
              v-else
              type="text"
              size="small"
              @click="haddleUnBindRole(scope.row)"
            >
              角色解绑
            </el-button> -->
              <el-button
                type="text"
                size="small"
                @click="changeRole(scope.row)"
              >
                角色变更
              </el-button>
              <el-button
                v-if="scope.row.is_sync_yundian === 1"
                type="text"
                size="small"
                @click="handleFreeze(scope.row)"
              >
                <span v-if="scope.row.salesperson_status === 1">冻结</span>
                <span v-if="scope.row.salesperson_status === 2">解冻</span>
              </el-button>
              <el-button
                v-if="scope.row.is_sync_yundian === 1 && scope.row.special_identity !== 2"
                type="text"
                size="small"
                @click="downloadCode(scope.row)"
              >
                下载导购码
              </el-button>
              <el-button
                v-if="scope.row.is_sync_yundian === 0"
                type="text"
                size="small"
                @click="handleRetry(scope.row)"
              >
                重试
              </el-button>
              <el-button
                v-if="scope.row.is_sync_yundian === 0"
                type="text"
                size="small"
                @click="handleDel(scope.row)"
              >
                删除
              </el-button>
            </template>
            <el-button
              type="text"
              size="small"
              @click="changeSalesOrganization(scope.row)"
            >
              变更店铺
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

      <!-- 冻结/解冻模态框 -->
      <el-dialog
        title="变更冻结状态"
        :visible.sync="freezeVisible"
        width="600px"
        :before-close="dialogFreezeClose"
      >
        <div>
          <el-radio-group v-model="freezeStatus">
            <el-radio :label="1">
              冻结
            </el-radio>
            <el-radio :label="2">
              解冻
            </el-radio>
          </el-radio-group>
        </div>
        <div slot="footer">
          <el-button @click="freezeVisible = false">
            取 消
          </el-button>
          <el-button
            type="primary"
            :loading="freezeloading"
            @click="submitFreeze"
          >
            确 定
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="查看销售群组"
        :visible.sync="groupListVisible"
        width="900px"
      >
        <div>
          <el-table
            :data="groupData.group"
            style="width: 100%"
          >
            <el-table-column
              prop="group_name"
              label="群组名称"
              width="180"
            />
            <el-table-column
              prop="group_code"
              label="群组编码"
              width="180"
            />
            <el-table-column
              prop="group_path_name"
              label="父级群组"
              width="180"
            />
            <el-table-column
              prop="desc"
              label="描述"
              width="180"
            />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="removeGroup(scope)"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>

      <!-- 变更绑定角色模态框 -->
      <SpChooseSalespersonType
        v-model="bindRoleVisible"
        :special-identity="specialIdentity"
        @chooseType="submitBindRole"
      />

      <!-- 批量导出导购码 -->
      <ExportGuideCode
        :code-visible="guideCodeVisible"
        @closeDialog="dialogGuideCodeClose"
      />

      <!-- 更新数据 -->
      <RefreshStore
        :refresh-visible="refreshStoreVisible"
        @closeRefreshStoreDialog="closeRefreshStoreDialog"
        @submitRefreshStore="haddleSearch"
      />
    </div>
    <!-- 批量导入 -->
    <SpBulkImport
      v-model="importVisible"
      file-type="saleman_bind_store"
      title="批量导入导购绑定门店"
      is-show-download="true"
      @saveImportAction="saveImportAction"
    >
      <div>
        批量导入说明： <br>
        1、下载导购关联门店信息模版文件<br>
        2、根据填写要求填写导购关联门店数据，上传并导入文件，文件格式必须为xlsx<br>
        3、单次上传xlsx最大条目数（行数）为5000，超出请按文件分批上传<br>
        4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传
      </div>
    </SpBulkImport>

    <!-- 变更销售组织 -->
    <SpSalesOrganization
      v-model="salesOrganizationVisible"
      :show-store="showStore"
      :show-group="showGroup"
      choose-only-store
      :select-data="salesData"
      @saveBindOrganization="saveBindOrganization"
    />
  </div>
</template>
<script>
import {
  getSalesmanList,
  updateFreeze,
  getSalesersonCode,
  syncRetry,
  salespersonDel
} from '@/api/staffManagement/salesman'
import { getRoleList, bindRole, unBindRole } from '@/api/staffManagement/rolePrivileges'
import RefreshStore from '@/components/refreshStore'
import ExportGuideCode from '../components/exportGuideCode'
// import qwContacts from '@/components/qwContacts'
export default {
  name: 'Salesman',
  components: {
    RefreshStore,
    ExportGuideCode
    // qwContacts
  },
  data () {
    return {
      tabList: [
        { name: 'all', label: '全部' },
        { name: 'employee', label: '员工' },
        { name: 'external_employee', label: '编外' },
        { name: 'opening', label: '已启用' },
        { name: 'disabled', label: '已禁用' },
        { name: 'freezing', label: '已冻结' },
        { name: 'is_sync_yundian', label: '同步失败' }
      ],
      activeName: 'all', //选中的tab
      list: [], //列表数据
      loading: false, //表格的加载
      params: {
        page: 1,
        page_size: 20,
        employee_status: 'all', //查询状态 [all 全部] [employee 员工] [external_employee 编外]
        salesperson_status: '', //禁用状态 [disabled 禁用] [opening 启用] [freezing 冻结]
        role_id: '',
        salesperson_job: '',
        store_id: ''
      },
      total_count: 0, //总数据量
      refreshStoreVisible: false, //更新数据展示与否

      multipleSelection: [], //多选列表

      bindRoleVisible: false, //变更绑定角色
      roleList: [], //角色列表
      setRoleSaleIds: '', //更改角色的员工id值，支持单个和多个

      setFreezeSaleIds: '', //更改冻结状态的员工id值，支持多个和单个
      freezeStatus: 0, //冻结状态
      freezeVisible: false, //冻结、解冻展示
      freezeloading: false, //冻结、解冻的加载

      guideCodeVisible: false, //导购码
      openid: 'openid',
      importVisible: false,

      options: {
        0: '导购',
        1: '店长',
        2: '运营'
      },

      salesOrganizationVisible: false,
      salesData: {
        selectedStoreIds: [],
        selectedGroupsIds: []
      },
      specialIdentity: '0',
      showStore: true,
      showGroup: true,
      setSalesPerson: {},
      groupListVisible: false,
      groupData: {}
    }
  },
  computed: {},
  mounted (data) {
    console.log('mounted-this', this)
    console.log('mounted-data', data)
    this.getRoleList()
    this.getList()
    // setTimeout(() => {
    //   this.getWxInvoke()
    // }, 3000)
  },
  methods: {
    // 移除运营人员绑定区域
    removeGroup (row) {
      const that = this,
        _row = row.row,
        { salesperson_id, group } = this.groupData
      this.$confirm('请确认要移除该销售群组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            action_type: 'remove',
            group_codes: [_row.group_code],
            salesperson_id: salesperson_id
          }
          that.$api.salesperson.saveBindGroup(params).then((res) => {
            const delIdx = group.find((d, idx) => {
              if (d.group_code == _row.group_code) return idx
            })
            group.splice(delIdx, 1)
            that.$set(this.groupData, 'group', group)
            that.$message({
              type: 'success',
              message: '移除成功!'
            })
          })
        })
        .catch(() => {})

      console.log('groupData', this.groupData)
      console.log('row', row)
    },
    getWxInvoke () {
      // WWOpenData.bind(this.$el)
      console.log('获取外部联系人')
      window.wx.invoke(
        'selectExternalContact',
        {
          'filterType': 0, //0表示展示全部外部联系人列表，1表示仅展示未曾选择过的外部联系人。默认值为0；除了0与1，其他值非法。在企业微信2.4.22及以后版本支持该参数
          'mode': 'single',
          'type': ['user']
        },
        function (res) {
          console.log('表示展示全部外部联系人列表', res)
        }
      )
    },
    // 获取导购列表
    async getList () {
      this.loading = true
      const data = await getSalesmanList(this.params)
      if (data) {
        let newData = data.list.map((element) => {
          return Object.assign(element, {
            storeCount: '',
            freeze: 0
          })
        })
        this.list = newData
        this.total_count = Number(data.total_count)
        this.loading = false
      }
    },

    // 导购列表点击切换tab
    handleClick () {
      if (
        this.activeName === 'all' ||
        this.activeName === 'employee' ||
        this.activeName === 'external_employee'
      ) {
        this.params.employee_status = this.activeName
        this.params.salesperson_status = ''
        this.params.is_sync_yundian = null
      } else if (this.activeName === 'is_sync_yundian') {
        this.params.employee_status = ''
        this.params.salesperson_status = ''
        this.params.is_sync_yundian = 'false'
      } else {
        this.params.salesperson_status = this.activeName
        this.params.employee_status = ''
        this.params.is_sync_yundian = null
      }

      this.params.page = 1
      this.getList()
    },

    // 导购列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 导购列表数据查询
    haddleSearch () {
      this.params.page = 1
      this.getList()
    },

    // 更新导购列表
    haddleRefresh () {
      this.refreshStoreVisible = true
    },
    closeRefreshStoreDialog () {
      this.refreshStoreVisible = false
    },

    // 多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    // 获取绑定角色列表数据
    async getRoleList () {
      const data = await getRoleList({ page: 1, page_size: 100 })
      if (data) {
        this.roleList = data.list
      }
    },
    // 角色解绑
    haddleUnBindRole (row) {
      this.$confirm('此操作将解绑角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let salesperson_id = row.salesperson_id.toString()
        const data = await unBindRole({ salesperson_id })
        if (data) {
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      })
    },
    // 更改角色
    haddleBindRole () {
      if (this.multipleSelection.length <= 0) {
        return this.$message.error('请至少勾选一个需要变更角色的员工')
      }
      this.specialIdentity = '0'
      let setRoleSaleIds = []
      this.multipleSelection.forEach((v) => {
        setRoleSaleIds = setRoleSaleIds.concat(v.salesperson_id)
      })
      this.setRoleSaleIds = setRoleSaleIds.join(',')
      this.bindRoleVisible = true
    },
    // 关闭绑定角色
    dialogBindRoleClose () {
      this.bindRoleVisible = false
    },
    // 确定绑定
    async submitBindRole (data) {
      this.updateSpecialIdentity(this.setRoleSaleIds, data.special_identity)
    },

    // 冻结解冻操作
    handleFreeze (row) {
      if (row) {
        this.freezeStatus = row.salesperson_status
        this.setFreezeSaleIds = row.salesperson_id.toString()
      } else {
        if (this.multipleSelection.length <= 0) {
          return this.$message.error('请至少勾选一个需要变更冻结或解冻的员工')
        }
        this.freezeStatus = 0
        let setFreezeSaleIds = []
        this.multipleSelection.forEach((v) => {
          setFreezeSaleIds = setFreezeSaleIds.concat(v.salesperson_id)
        })
        this.setFreezeSaleIds = setFreezeSaleIds.join(',')
      }
      this.freezeVisible = true
    },
    // 确定冻结、解冻
    async submitFreeze () {
      let salesperson_status = this.freezeStatus
      let params = {
        salespersonId: this.setFreezeSaleIds,
        // 导购状态，2：冻结；1：启用、解冻
        salesperson_status: salesperson_status === 1 ? 2 : salesperson_status === 2 ? 1 : ''
      }
      const data = await updateFreeze(params).catch(() => {
        this.freezeloading = false
      })
      if (data) {
        this.freezeloading = false
        this.freezeVisible = false
        this.$message({
          message: '变更成功',
          type: 'success'
        })
        this.getList()
      }
    },
    // 关闭冻结、解冻
    dialogFreezeClose () {
      this.freezeVisible = false
    },

    downloadIamge (imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc + '?time=' + Date.now()
    },
    // 下载导购码
    async downloadCode (item) {
      const data = await getSalesersonCode(item.salesperson_id)
      if (data) {
        this.downloadIamge(data.qr_code, item.salesperson_name)
      }
    },
    async haddleGuideCode () {
      this.guideCodeVisible = true
    },
    dialogGuideCodeClose () {
      this.guideCodeVisible = false
    },
    // 确定导入
    saveImportAction () {
      this.params.page = 1
      this.getList()
    },
    //导购删除
    handleDel (row) {
      this.$confirm('此操作将删除本行数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let salesperson_id = row.salesperson_id.toString()
        const data = await salespersonDel(salesperson_id)
        if (data) {
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      })
    },

    //同步失败重试
    async handleRetry (row) {
      let params = {}
      if (row) {
        params.user_ids = row.employee_number.toString()
      } else {
        if (this.multipleSelection.length <= 0) {
          return this.$message.error('请至少勾选一个需要重试同步的员工')
        }
        let refreshUserIds = []
        this.multipleSelection.forEach((v) => {
          refreshUserIds = refreshUserIds.concat(v.employee_number)
        })
        params.user_ids = refreshUserIds.join(',')
      }
      const data = await syncRetry(params).catch(() => {
        this.loading = true
      })
      if (data) {
        this.$message({
          message: '同步处理中，稍后刷新查看',
          type: 'success'
        })
        this.loading = false
        this.getList()
      }
    },

    // 变更单个角色
    changeRole (row) {
      // this.updateSpecialIdentity(row.salesperson_id.toString(), row.special_identity)
      this.specialIdentity = String(row.special_identity)
      this.setRoleSaleIds = row.salesperson_id
      this.bindRoleVisible = true
    },
    async updateSpecialIdentity (salespersonId, special_identity) {
      const data = await this.$api.salesperson
        .changeSpecialIdentity({
          salespersonId,
          special_identity
        })
        .catch(() => {
          this.getList()
        })
      if (data) {
        this.$message({
          message: '变更成功',
          type: 'success'
        })
        this.bindRoleVisible = false
        this.getList()
      } else {
        this.getList()
      }
    },

    // 选择门店
    chooseStore (store_bn, store_id) {
      this.params.store_id = store_id
    },

    // 批量变更销售组织
    relationSalesOrganization () {
      if (this.multipleSelection.length <= 0) {
        return this.$message.error('请至少勾选一个需要变更销售组织的员工')
      }
      // 批量关联
      this.showStore = true
      this.showGroup = true
      this.salesOrganizationVisible = true
    },

    // 变更销售组织
    changeSalesOrganization (row) {
      // 导购、店长只显示门店列表，运营只显示销售群组
      if (String(row.special_identity) === '2') {
        this.showStore = false
        this.showGroup = true
      } else {
        this.showStore = true
        this.showGroup = false
      }
      this.salesOrganizationVisible = true
      this.salesData = {
        selectedStoreIds: String(row.store_id).split(','),
        selectedGroupsIds: row.group
      }
      this.setSalesPerson = row
    },

    // 确定绑定销售组织
    async saveBindOrganization (selectData, type) {
      let params = {}
      if (this.setSalesPerson && this.setSalesPerson.salesperson_id) {
        params.salesperson_id = this.setSalesPerson.salesperson_id
      } else {
        params.salesperson_id = this.multipleSelection.map((v) => v.salesperson_id).join(',')
      }
      params.action_type = 'add'
      if (type === 'store') {
        // 绑定店铺
        params.store_ids = selectData.join(',')
        params.employee_status = this.setSalesPerson.employee_status
        const data = this.$api.salesperson.saveBindStore(params)
        if (data) {
          setTimeout(() => {
            this.$message.success('变更成功')
            this.salesOrganizationVisible = false
            this.getList()
          }, 1500)
        }
      } else {
        // 绑定群组
        params.group_codes = selectData.map((d) => d.group_code)
        const del_group_codes = []
        this.salesData.selectedGroupsIds.forEach((d) => {
          if (!selectData.find((dd) => dd.id == d.id)) {
            del_group_codes.push(d.group_code)
          }
        })

        params.del_group_codes = del_group_codes
        const data = await this.$api.salesperson.saveBindGroup(params)
        if (data) {
          setTimeout(() => {
            this.$message.success(data.notice)
            this.salesOrganizationVisible = false
            this.getList()
          }, 1500)
        }
      }
    },
    showGroupDetail (row) {
      this.groupData = row
      this.groupListVisible = true
    },
    relationShops () {
      if (this.multipleSelection.length <= 0) {
        return this.$message.error('请至少勾选一个需要变更销售组织的员工')
      }
      // 批量关联
      this.showStore = true
      this.showGroup = false
      this.salesOrganizationVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  li {
    margin-right: 20px;
    margin-bottom: 20px;
  }
}
.upload-preview {
  text-align: center;
  max-width: 200px;
  border: 1px solid #ddd;
  padding: 10px;
  position: relative;
  img {
    max-width: 200px;
    margin: 0 auto;
  }
}
.text-ellipsis {
  display: inline-block;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.bind-store {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.store-select-item {
  display: flex;
  align-items: center;
}
.operation {
  margin-bottom: 20px;
}
::v-deep {
  .role-select {
    width: 80px;
    .el-input {
      display: flex;
      input {
        min-width: 80px;
        border: none;
        background-color: transparent;
      }
    }
  }
}
</style>
